import React, { FC, InputHTMLAttributes } from 'react'

import * as SC from './styled'

export type FormCheckboxProps = Omit<InputHTMLAttributes<HTMLInputElement>, 'value'> & {
  className?: string
  name: string
  checked?: boolean
  value?: string
  label?: string
  required?: boolean
  disabled?: boolean
  error?: string
  showError?: boolean
  help?: string
  isGroupChild?: boolean
}

const FormCheckbox: FC<FormCheckboxProps> = (props) => {
  const { className, label, error, showError, help, isGroupChild, ...inputProps } = props

  return (
    <SC.Container className={className} $isDisabled={!!inputProps.disabled}>
      <SC.Label $isDisabled={!!inputProps.disabled}>
        <SC.Checkbox {...inputProps} type="checkbox" $isError={isGroupChild ? false : !!error} />
        {label && (
          <SC.LabelText
            $required={!!inputProps.required}
            $isError={isGroupChild ? false : !!error}
            dangerouslySetInnerHTML={{ __html: label }}
          />
        )}
      </SC.Label>
      {help && <SC.Help>{help}</SC.Help>}
      {error && showError && <SC.Error>{error}</SC.Error>}
    </SC.Container>
  )
}

export default FormCheckbox
